import { render } from "./ManagePeopleUserActivity.vue?vue&type=template&id=42fed514&lang=pug"
import script from "./ManagePeopleUserActivity.vue?vue&type=script&lang=js"
export * from "./ManagePeopleUserActivity.vue?vue&type=script&lang=js"

import "./ManagePeopleUserActivity.vue?vue&type=style&index=0&id=42fed514&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__